import React from 'react';

import { Box, Typography } from '@mui/material';
import BookingPriceDetails from './BookingPriceDetails';

import { useSelector } from 'react-redux';

import InfoValueRow from '@shared/components/InfoValueRow';

const BookingPriceSummary = ({ price, isPayment, cardData }) => {
  const { business_types } = useSelector(store => store.pageConfiguration);

  const isB2B = business_types.id === 2;
  const showNetPrice = isB2B && !isPayment;

  let chargesText = '';

  if (+price.details.charges === 0) {
    chargesText = 'Las tarifas publicadas no incluyen gastos administrativos.';
  } else {
    chargesText = 'Las tarifas publicadas incluyen gastos administrativos.';
  }

  return (
    <React.Fragment>
      {showNetPrice ? (
        <InfoValueRow
          label={'Neto total'}
          value={price?.details_USD?.b2b?.total ?? 0}
          isPrice
          isInUSD
          color="red"
          boldLeft
          boldRight
          fontSize={{ xs: '17px', md: '18px', lg: '15px', xl: '18px' }}
        />
      ) : (
        <BookingPriceDetails
          details={price.details}
          showTitle={isPayment}
          isInUSD={false}
          cardData={cardData}
          currencyValue={price?.currency_value}
          chargesMessage={Number(price.details?.charges) === 0}
        />
      )}
      {isB2B && !isPayment && (
        <Box sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: '13px' }}>{chargesText}</Typography>
          <Typography sx={{ fontSize: '13px' }}>
            Una vez confirmada la reserva, nuestro equipo les enviará la
            liquidación correspondiente.
          </Typography>
          <br />
        </Box>
      )}
    </React.Fragment>
  );
};

export default BookingPriceSummary;
